import React, { useRef, useState } from "react";
import { BuildingOfficeIcon } from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import DownloadButton from "../../../../components/DownloadButton";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import useGetBillsOfficeHierarchy from "./hooks/useGetBillsOfficeHierarchy";
import { accountAtom } from "../../../Login/atoms/AccountAtom";

interface BillsOfficeHierarchyReportProps {}
export const BillsOfficeHierarchyReport: React.FC<BillsOfficeHierarchyReportProps> =
  () => {
    const [exportData, setExportData] = useState([]);
    const { data: officeHierarchy, isLoading: officeHierarchyLoading } =
      useGetBillsOfficeHierarchy();
    const tableRef = useRef<any>([]);
    const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
    const history = useHistory();
    const userPermissions = useRecoilValue(permissionsSelector);
    const user = useRecoilValue(accountAtom);

    interface IOfficeHierarchy {
      officeName: string;
      districtCode: string;
      officeHierarchy: string;
      districtManager: string;
      districtManagerEmail: string;
      regionCode: string;
      territoryCode: string;
      salesVp: string;
      salesVpEmail: string;
      areaCode: string;
      salesPresident: string;
      salesPresidentEmail: string;
    }

    //For downloading table data
    const mapDataToExport = (data) => {
      setExportData(
        data?.map((ohr: IOfficeHierarchy) => {
          return {
            "Office Name": ohr.officeName,
            "District Code": ohr.districtCode,
            "Office Hierarchy: Name": ohr.officeHierarchy,
            "District Manager": ohr.districtManager,
            "District Manager Email": ohr.districtManagerEmail,
            "Region Code": ohr.regionCode,
            "Territory Code": ohr.territoryCode,
            "Sales VP": ohr.salesVp,
            "Sales VP Email": ohr.salesVpEmail,
            "Area Code": ohr.areaCode,
            "Sales President": ohr.salesPresident,
            "Sales President Email": ohr.salesPresidentEmail,
          };
        })
      );
    };
    let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
    const csvReport = {
      filename: "BillsOfficeHierarchyReport_" + dateTimeToday + ".csv",
      data: exportData,
    };

    const officeColumns = [
      {
        title: "Office Name",
        field: "officeName",
        render: (rowData) => {
          return (
            <div
              className="cursor-pointer"
              onClick={() => {
                const url = "/officesettings/officesetting";
                history.push({
                  pathname: url,
                  state: {
                    pathname: url,
                    officeCode: rowData?.officeCode,
                    action: "BillsOfficeHierarchy",
                  },
                });
                window.location.reload();
                let userTabs = [
                  {
                    to: "",
                  },
                ];
                [...OfficeTabs].forEach((tabs) => {
                  let temp = [...userPermissions].filter(
                    (user) => user === tabs.permission
                  );
                  if (temp.length > 0)
                    userTabs.push({
                      to: tabs.to,
                    });
                });
                userTabs.shift();
                const index = userTabs.findIndex((c) => c.to === url);
                setSelectedIndex(index);
              }}
            >
              <span className="text-quinary  font-bold underline text-sm ">
                {rowData.officeName}
              </span>
            </div>
          );
        },
      },
      { title: "District Code", field: "districtCode" },
      { title: "Office Hierarchy: Name", field: "officeHierarchy" },
      { title: "District Manager", field: "districtManager" },
      { title: "District Manager Email", field: "districtManagerEmail" },
      { title: "Region Code", field: "regionCode" },
      { title: "Territory Code", field: "territoryCode" },
      { title: "Sales VP", field: "salesVp" },
      { title: "Sales VP Email", field: "salesVpEmail" },
      { title: "Area Code", field: "areaCode" },
      { title: "Sales President", field: "salesPresident" },
      { title: "Sales President Email", field: "salesPresidentEmail" },
    ];

    return (
      <div className="text-xs items-center">
        <div className="">
          <div className="mx-4 mt-4 overflow-x-auto">
            <div className="flex mb-2 gap-2 items-center">
              <div>
                <BuildingOfficeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading tight">
                <div className="text-gray-500 text-md font-medium">
                  Report: Accounts
                </div>
                <div className="flex items-center font-bold text-lg text-primary">
                  Bill's Office Hierarchy Report{" "}
                </div>
              </div>
            </div>
            <div className="mt-2" />
            <div className="flex justify-between mb-2 mr-2">
              <div className="flex items-center gap-1">
                <span className="text-gray-500 text-sm">Total Records: </span>
                <span className="text-primary text-base font-semibold">
                  {
                    officeHierarchy?.filter((x) =>
                      user?.isFranchise && user?.isNonFranchise
                        ? true
                        : user?.isFranchise
                        ? x.officeType?.toLowerCase() === "franchise"
                        : x.officeType?.toLowerCase() !== "franchise"
                    ).length
                  }
                </span>
              </div>
              <CSVLink className="" {...csvReport}>
                <DownloadButton
                  buttonValue="Download File"
                  onClick={() =>
                    mapDataToExport(tableRef.current.dataManager.searchedData)
                  }
                  className={undefined}
                  disabled={undefined}
                />
              </CSVLink>
            </div>
          </div>
          <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
            <MaterialTableTS
              data={officeHierarchy?.filter((x) =>
                user?.isFranchise && user?.isNonFranchise
                  ? true
                  : user?.isFranchise
                  ? x.officeType?.toLowerCase() === "franchise"
                  : x.officeType?.toLowerCase() !== "franchise"
              )}
              isLoading={officeHierarchyLoading}
              columns={officeColumns}
              showTitle={false}
              showToolbar={true}
              toolbarSearch={true}
              searchFieldAlignment="left"
              tableRef={tableRef}
            />
          </div>
        </div>
      </div>
    );
  };
